/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
export type Availability_Status_Enum =
  | 'AVAILABLE'
  | 'UNAVAILABLE';

export type Base_Unit_Type_Enum =
  | 'BAG'
  | 'BAG_IN_BOX'
  | 'BOTTLE'
  | 'BOX'
  | 'BOX_SET'
  | 'BULK'
  | 'CAN'
  | 'CARTON'
  | 'CUP'
  | 'FLASK'
  | 'JAR'
  | 'KEG'
  /**   */
  | 'NET'
  | 'PACK'
  | 'PIECE'
  | 'SACHET'
  | 'SLICE'
  | 'SPRAY'
  | 'TIN'
  | 'TRAY'
  /**   */
  | 'TUB'
  | 'TUBE';

export type Billing_Type_Enum =
  /** billed per unit */
  | 'FIXED'
  /** billed per measured weight */
  | 'WEIGHT_DEPENDENT';

export type Gtin_Type_Enum =
  | 'GTIN_8'
  | 'GTIN_12'
  | 'GTIN_13'
  | 'GTIN_14';

export type Measurement_Unit_Enum =
  | 'CL'
  | 'G'
  | 'KG'
  | 'L'
  | 'ML'
  | 'T'
  /** Used to count units in logistical packages */
  | 'UNIT';

export type Product_Label_Name_Enum =
  | 'AGRICULTURE_BIOLOGIQUE'
  | 'APPELLATION_ORIGINE_CONTROLEE'
  | 'APPELLATION_ORIGINE_PROTEGEE'
  | 'ECOCERT_ECODETERGENT'
  | 'GOUTEZ_ARDECHE'
  | 'HAUTE_VALEUR_ENVIRONNEMENTALE'
  | 'INDICATION_GEOGRAPHIQUE_PROTEGEE'
  | 'LABEL_ROUGE'
  | 'LE_PORC_FRANCAIS'
  | 'NATURE_ET_PROGRES'
  | 'ORIGINE_FRANCE_GARANTIE'
  | 'PRODUIT_ILE_DE_FRANCE'
  | 'SAVEURS_DE_NORMANDIE'
  | 'VALEURS_PARC_NATUREL_REGIONAL';

export type Social_Tag_Type_Enum =
  | 'ENGAGED_STORE'
  | 'GUARANTEED_SALES'
  | 'HIDDEN_GEM'
  | 'HIGHLY_RESPONSIVE'
  | 'HIGH_MARGIN'
  | 'NEW_ARRIVAL'
  | 'POPULAR'
  | 'TREND';

export type Trade_Item_Unit_Descriptor_Enum =
  | 'CASE'
  | 'CRATE'
  | 'DISPLAY'
  | 'HALF_CASE'
  | 'PALLET'
  | 'SACK'
  /** Used when base units are sold individually */
  | 'UNIT';

export type PackagingFragmentFragment = { id: string, company_id: string, base_unit_id: string, product_id: string, gtin: string | null, gtin_type: Types.Gtin_Type_Enum | null, sku: number, price: number, trade_item_unit_descriptor: Types.Trade_Item_Unit_Descriptor_Enum, unit_quantity: number | null, content_measurement_unit: Types.Measurement_Unit_Enum | null, net_content: number | null, base_unit: { id: string, sku: number | null, billing_type: Types.Billing_Type_Enum, content_measurement_unit: Types.Measurement_Unit_Enum | null, gtin: string | null, unit_type: Types.Base_Unit_Type_Enum | null, unit_quantity: number | null, unit_net_content: number | null, suggested_retail_price: number | null, availability: Types.Availability_Status_Enum, product_id: string, main_photo: { path: string, domain: string | null } | null, photos: Array<{ photo: { path: string, domain: string | null } }>, social_tags: Array<{ values: { [key: string]: any } | null, type: Types.Social_Tag_Type_Enum, priority: number, level: number }> }, product: { name: string, sku: number, sub_family: string, vat_rate: number | null, labels: Array<{ label: Types.Product_Label_Name_Enum }> } };

export const PackagingFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment packagingFragment on packaging {
  id
  company_id
  base_unit_id
  product_id
  gtin
  gtin_type
  sku
  price
  trade_item_unit_descriptor
  unit_quantity
  content_measurement_unit
  net_content
  base_unit {
    id
    sku
    billing_type
    content_measurement_unit
    gtin
    unit_type
    unit_quantity
    unit_net_content
    suggested_retail_price
    availability
    product_id
    main_photo {
      path
      domain
    }
    photos {
      photo {
        path
        domain
      }
    }
    social_tags {
      values
      type
      priority
      level
    }
  }
  product {
    name
    sku
    sub_family
    vat_rate
    labels {
      label
    }
  }
}
    `;